import { useState } from "react";
import { Typography, Spin } from "antd";

import CheckIcon from "@/icons/CheckIcon";

const CopyFrom = ({
  text = "Копировать из родителя",
  successText = "Скопировано",
  showAction = true,
  onChange,
  children,
}) => {
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleClick = async () => {
    try {
      setLoading(true);
      const res = await onChange();
      if (res !== false) {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }
    } finally {
      setLoading(false);
    }
  };

  const disabled = !showAction || loading;

  return (
    <Spin spinning={loading}>
      <div style={{ position: "relative" }}>
        {children}

        {showAction && (
          <Typography.Link
            onClick={disabled ? undefined : handleClick}
            style={{
              fontSize: 12,
              position: "absolute",
              right: 0,
              top: 3,
              opacity: disabled ? 0.5 : 1,
              pointerEvents: disabled || copied ? "none" : "auto",
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            {copied ? (
              <>
                <CheckIcon style={{ fontSize: 14, color: "#52c41a" }} />
                {successText}
              </>
            ) : (
              <>{text}</>
            )}
          </Typography.Link>
        )}
      </div>
    </Spin>
  );
};

export default CopyFrom;
